
import { mapMutations, mapGetters, mapActions } from 'vuex';
import vClickOutside from 'v-click-outside';

import MenuItems from '@/components/MenuItems';
import HeaderMobileEcom from '~/components/header/HeaderMobileEcom';
import ProfileFilledIcon from '@/components/svg/ProfileFilledIcon.vue';
import ProfileEmptyIcon from '@/components/svg/ProfileEmptyIcon.vue';
import FavoritesClearIcon from '@/components/svg/FavoritesClearIcon.vue';
import CompareIcon from '@/components/svg/CompareIcon.vue';
import CartIcon from '@/components/svg/CartIcon.vue';
import SearchFormCasa from '@/components/header/SearchFormCasa.vue';

import header from '~/mixins/header';
import HeaderNavigationMixin from '~/mixins/HeaderNavigationMixin';

export default {
    mixins: [header, HeaderNavigationMixin],
    components: {
        MenuItems,
        HeaderMobileEcom,
        ProfileFilledIcon,
        ProfileEmptyIcon,
        FavoritesClearIcon,
        CompareIcon,
        SearchFormCasa,
        CartIcon,
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    data() {
        return {
            onScrollIs: false,
            fixedIs: false,
            scrollPos: 100,
            isShow: false,
        };
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            isVitrina: 'global/isVitrina',
            isNovaPorta: 'global/getIsNovaPorta',
            getCurrentTheme: 'global/getCurrentTheme',
            getHeaderStyle: 'global/getHeaderStyle',
            cartProductsLength: 'cart/getProductsLength',
            favoritesProductsLength: 'favorites/getProductsLength',
            compareProductsLength: 'compare/getCompareProductsLength',
            getModalShow: 'search/getModalShow',
        }),
        isDisplaySearch() {
            return this.globalSettings?.mainUiInterface?.header_search_type === 'default';
        },
        currentLocaleName() {
            return this.$i18n.locales?.filter(i => i?.code === this.$i18n.locale)[0]?.code;
        },
    },
    mounted() {
        if (process.browser) {
            window.addEventListener('scroll', this.handleScroll);
            this.favoritesProducts();
            this.compareProducts();
        }
    },

    destroyed() {
        if (process.browser) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    },
    methods: {
        ...mapMutations({
            initFavoritesProducts: 'favorites/initFavProducts',
            initCompareProducts: 'compare/initCompareProducts',
        }),
        ...mapActions({
            openCart: 'cart/openCart',
        }),
        ...mapMutations('search', ['setModalShow']),
        favoritesProducts() {
            if (process.client && localStorage?.getItem('favorites')) {
                this.initFavoritesProducts(JSON.parse(localStorage?.getItem('favorites')));
            } else {
                this.initFavoritesProducts([]);
            }
        },
        compareProducts() {
            if (process.client && localStorage?.getItem('compare')) {
                this.initCompareProducts(JSON.parse(localStorage?.getItem('compare')));
            } else {
                this.initCompareProducts([]);
            }
        },
        setActiveClass(path) {
            // Вспомогательная функция для получения последнего непустого сегмента URL
            const getLastSegment = fullPath => {
                const segments = fullPath.split('/').filter(segment => segment.length > 0);
                return segments[segments.length - 1] || '';
            };

            const currentSegment = getLastSegment(this.$route.path);
            const linkSegment = getLastSegment(path);

            // Если требуется точное совпадение:
            // return currentSegment === linkSegment ? 'active' : '';

            // Если требуется, чтобы активным считался элемент, если последний сегмент маршрута содержит ссылочный сегмент:
            return currentSegment.includes(linkSegment) ? 'active' : '';
        },
        closeLangMenu() {
            this.isShow = false;
        },
        handleScroll() {
            this.fixedIs = false;
            if (window.scrollY > 100) {
                this.onScrollIs = true;

                if (this.getHeaderStyle !== 'sticky') {
                    if (window.scrollY < this.scrollPos) {
                        this.fixedIs = true;
                    }
                    this.scrollPos = window.scrollY;
                }
            } else {
                this.onScrollIs = false;
            }
        },
        redirectTo(path) {
            this.setIsCabinetWindowOpen(false);
            this.$router.push(this.localePath(path));
        },
    },
};
